import { configureStore } from '@reduxjs/toolkit';

import langReducer from '@/configuration/lang/langSlice';
import appReducer from '@/features/app/appSlice';
import configReducer from './configSlice';
import locationReducer from './locationSlice';

export const store = configureStore({
    reducer: {
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        location: locationReducer,
    },
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(...),
});

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
